import React from 'react'
import {
  IconSystemBasketAdd,
  IconSystemCardAdd,
  IconSystemPencil,
  IconSystemPlus,
} from '@moonpig/launchpad-assets'
import { ProductTileCtaEnum } from '../getProductTileCta'

const ICON_PROPS = {
  width: '24px',
  height: '24px',
  color: 'white',
}

export const getGiftTileCtaIcon = (ctaType: ProductTileCtaEnum) => {
  switch (ctaType) {
    case ProductTileCtaEnum.Personalise:
      return <IconSystemPencil {...ICON_PROPS} />
    case ProductTileCtaEnum.AddToCard:
      return <IconSystemCardAdd {...ICON_PROPS} />
    case ProductTileCtaEnum.SelectSize:
    case ProductTileCtaEnum.SelectAmount:
      return <IconSystemPlus {...ICON_PROPS} />
    case ProductTileCtaEnum.AddToBasket:
      return <IconSystemBasketAdd {...ICON_PROPS} />
  }
}
